require('bijou/base')

#== Description
# This widget handles the display of the interstitial on partners
#
#== Behaviour
# On clicking ".partner-transfer" element on the partner quote details page:
# - the interstitial is displayed
# - adds a 6-second artificial delay before following the link on the trigger element

"use strict"

$.widget "chopin.interstitial", $.bijou.base,
  options:
    delay: 6000

  _create: ->
    # Ensure interstitial is hidden when user navigates back.
    # 'pageshow' fires even when the page is retrieved from
    # the browser's 'bfcache' (previous dom state) eg. Safari
    partnerTransferEventTarget = null
    @window.on "pageshow", ->
      $("body").removeClass("interstitial-on")

    @_on
      "click .partner-transfer": (e, options) ->
        partnerTransferEventTarget = e.target
        return true if (options && options.alreadyDelayed)

        e.preventDefault()
        e.stopPropagation()

        $("body").addClass("interstitial-on")

        @_trackInterstitialShown()
        _this = @
        @submitTimeout = window.setTimeout ->
          _this._preventFurtherClicks()
          if $.nodeName( partnerTransferEventTarget, "a" )
            # special handling of 'a' elements,
            # since jQuery blocks programmatic 'click' events on 'a' elements
            # (see https://stackoverflow.com/q/7999806)
            window.location = $(partnerTransferEventTarget).attr("href")
          else
            _this._triggerSyntheticClick(partnerTransferEventTarget)
        , @options.delay

      "click .interstitial .continue-now": (e) ->
        e.preventDefault()
        e.stopPropagation()
        @_preventFurtherClicks()
        @_triggerSyntheticClick(partnerTransferEventTarget)

  _triggerSyntheticClick: (eventTarget) ->
    $(eventTarget).trigger('click', {
      alreadyDelayed: true, syntheticClick: true
    })

  _trackInterstitialShown: ->
    event = "partner_handover_interstitial_shown"
    site = $('meta[name="site"]').attr('content')
    setTimer = "set #{(@options.delay) / 1000} seconds"
    if window.EventTracker
      EventTracker.trigger(event, site, setTimer)

  _preventFurtherClicks: ->
    # preventing the same functionality from being trigerred more than once:
    # first - preventing the timeout set earlier from triggering
    window.clearTimeout(@submitTimeout)
    # also - preventing subsequent clicks on the 'continue now' button / link.
    # using 'setTimeout' in order to allow the _current_ click event
    window.setTimeout ->
      $('.interstitial .continue-now').prop('disabled', true)
        .bind('click', false)
    , 0
